/**
 * Renders the action buttons to the right of the app menu. i.e. Publish
 *
 * @package Ninja Forms builder
 * @subpackage App
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'views/app/menuButtons',[], function() {
	var view = Marionette.ItemView.extend({
		tagName: 'span',
		template: '#tmpl-nf-app-header-action-button',

		initialize: function() {
			// Listen to changes on the app 'clean' state. When it changes, re-render.
			this.listenTo( nfRadio.channel( 'app' ), 'change:clean', this.render, this );
			this.listenTo( nfRadio.channel( 'app' ), 'change:loading', this.render, this );

			this.listenTo( nfRadio.channel( 'app' ), 'response:updateDB', this.bounceIcon, this );
		},

		/**
		 * These functions are available to templates, and help us to remove logic from template files.
		 * 
		 * @since  3.0
		 * @return Object
		 */
		templateHelpers: function () {
			var that = this;
	    	return {

	    		/**
	    		 * Render our Publish button. If we're loading, render the loading version.
	    		 *
	    		 * @since  3.0
	    		 * @return string
	    		 */
	    		renderPublish: function() {
	    			if ( that.publishWidth ) {
	    				this.publishWidth = that.publishWidth + 'px';
	    			} else {
	    				this.publishWidth = 'auto';
	    			}

	    			if ( nfRadio.channel( 'app' ).request( 'get:setting', 'loading' ) ) {
	    				var template = nfRadio.channel( 'app' ).request( 'get:template',  '#tmpl-nf-add-header-publish-loading' );
	    			} else {
	    				var template = nfRadio.channel( 'app' ).request( 'get:template',  '#tmpl-nf-app-header-publish-button' );
	    			}
	    			return template( this );
	    		},

	    		/**
	    		 * If our app state is clean, disable publish.
	    		 * 
	    		 * @since  3.0
	    		 * @return string
	    		 */
	    		maybeDisabled: function() {
	    			if ( nfRadio.channel( 'app' ).request( 'get:setting', 'clean' ) ) {
	    				return 'disabled';
	    			} else {
	    				return '';
	    			}
	    		},

	    		/**
	    		 * [DEPRECATED] If our app isn't clean, render our 'viewChanges' button.
	    		 * @since  version
	    		 * @return {[type]} [description]
	    		 */
	    		maybeRenderCancel: function() {
					return '';
				},

	    		renderPublicLink: function() {
						// Don't show public link if the form has a temp ID
						var formModel = Backbone.Radio.channel('app').request('get:formModel');
						if (isNaN(formModel.get('id'))) { return };
						// Otherwise, display normally
	    			var publicLink = nfRadio.channel( 'app' ).request( 'get:template',  '#tmpl-nf-app-header-public-link' );
	    				return publicLink( this );
	    		},

				/**
				 * Render our AI Assistant button when the endpoint is available
				 * (an AI provider is connected and the form is saved).
				 *
				 * @return {string|undefined} Rendered button or no button when unavailable.
				 */
				renderAiAssistant: function() {
					if ( 'undefined' === typeof nfAiChat ) { return; }
					/*
					 * Deliberately not gated on a saved form, unlike the public
					 * link above. A missing control teaches the wrong rule: two
					 * reviewers concluded the assistant only worked on forms AI
					 * had generated. The drawer explains its own preconditions
					 * instead, and publishes on the first message.
					 */
					var aiAssistant = nfRadio.channel( 'app' ).request( 'get:template',  '#tmpl-nf-app-header-ai-assistant' );
					return aiAssistant( this );
				},
			};
		},

		onShow: function() {
			var publishEL = jQuery( this.el ).find( '.publish' );
			// this.publishWidth = jQuery( publishEL ).outerWidth( true );
		},

		/**
		 * Listen for clicks on the Publish or view changes button.
		 * @type {Object}
		 */
		events: {
			'click .publish': 'clickPublish',
			'click .viewChanges': 'clickViewChanges',
			'click .publicLink': 'clickPublicLink',
			'click .aiAssistant': 'clickAiAssistant',
		},

		/**
		 * When we click publish, trigger a radio event.
		 * This lets us separate the logic from the click event and view.
		 * 
		 * @since  3.0
		 * @param  Object 	e event
		 * @return void
		 */
		clickPublish: function( e ) {
			nfRadio.channel( 'app' ).trigger( 'click:publish', e );
		},

		/**
		 * When we click view changes, trigger a radio event.
		 * This lets us separate the logic from the click event and view.
		 * 
		 * @since  3.0
		 * @param  Object 	e event
		 * @return void
		 */
		clickViewChanges: function( e ) {
			nfRadio.channel( 'app' ).trigger( 'click:viewChanges', e );
		},

		clickPublicLink: function( e ) {
			nfRadio.channel( 'app' ).trigger( 'click:publicLink', e );
		},

		/**
		 * Forward an AI Assistant header-button click to the app channel.
		 *
		 * @param {Event} e Browser click event.
		 * @return {void}
		 */
		clickAiAssistant: function( e ) {
			nfRadio.channel( 'app' ).trigger( 'click:aiAssistant', e );
		},

		bounceIcon: function( changeModel ) {
			jQuery( this.el ).find( '.dashicons-backup' ).effect( 'bounce', { times: 3 }, 600 );
		}

	});

	return view;
} );

